import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    btn: {
      marginTop: '1rem',
    },
    container: {
      padding: '50px 40px',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
      textAlign: 'center',
    },
    message: {
      color: '#B12A2A !important',
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '1rem',
      textAlign: 'center',
    },
  };
});

export default ({ onAgree, onCancel }) => {
  const classes = useStyles();
  return (
    <Container maxWidth="xs" disableGutters className={classes.container}>
      <Grid container justify="center">
        <Typography variant="h4" className={`page-header ${classes.formTitle}`} align="left">
          Are you sure you want to cancel your annual subscription?
        </Typography>
        <Typography variant="body1" className={`body-copy ${classes.message}`} align="left">
          Do note that any Imaging files and video reports you may have requested will be removed from our system and will not be viewable from this point on.
        </Typography>
        <Grid item xs={12} justify="center" container>
          <Button variant="contained" color="primary" onClick={onAgree} className={classes.btn}>
            Yes, I’m sure
          </Button>
        </Grid>

        <Button color="primary" onClick={onCancel} className={classes.btn}>
          I want to keep my subscription
        </Button>
      </Grid>
    </Container>
  );
};
